import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { value: 'Italy' }
const _hoisted_7 = { value: 'Stato Estero' }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "mb-2 text-danger fw-bold" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_sesso = _resolveComponent("sesso")!
  const _component_splitted_date = _resolveComponent("splitted-date")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Nome",
          text: "Nome"
        })
      ]),
      _createElementVNode("input", {
        type: "text",
        class: "form-control",
        value: _ctx.localValue.personalData.name,
        disabled: true
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Cognome",
          text: "Cognome"
        })
      ]),
      _createElementVNode("input", {
        type: "text",
        class: "form-control",
        value: _ctx.localValue.personalData.surname,
        disabled: true
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Nazione di residenza",
          text: "Nazione di residenza"
        })
      ]),
      _withDirectives(_createElementVNode("select", {
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.personalData.country) = $event))
      }, [
        _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$localizationService.GetLocalizedValue('Italia', 'Italia')), 1),
        _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$localizationService.GetLocalizedValue('Stato Estero', 'Stato Estero')), 1)
      ], 512), [
        [_vModelSelect, _ctx.localValue.personalData.country]
      ])
    ]),
    (_ctx.needsFiscalCode)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", null, [
              _createElementVNode("u", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Inserisci il codice fiscale per compilare gli altri campi in automatico",
                  text: "Inserisci il codice fiscale per compilare gli altri campi in automatico"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Codice fiscale",
                text: "Codice fiscale"
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                (_ctx.codFiscError)
                  ? (_openBlock(), _createBlock(_component_localized_text, {
                      key: 0,
                      localizedKey: "Codice fiscale non valido",
                      text: "Codice fiscale non valido"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                (_ctx.codFiscNonCoerente)
                  ? (_openBlock(), _createBlock(_component_localized_text, {
                      key: 0,
                      localizedKey: "Il codice fiscale inserito non è coerente con gli altri dati",
                      text: "Il codice fiscale inserito non è coerente con gli altri dati"
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.fiscalData.fiscalCode) = $event))
            }, null, 512), [
              [_vModelText, _ctx.localValue.fiscalData.fiscalCode]
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Sesso",
          text: "Sesso"
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_sesso, {
          modelValue: _ctx.localValue.fiscalData.sex,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.fiscalData.sex) = $event)),
          readonly: _ctx.needsFiscalCode,
          onClick: _ctx.alertFiscalCode
        }, null, 8, ["modelValue", "readonly", "onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Data di nascita",
          text: "Data di nascita"
        })
      ]),
      _createVNode(_component_splitted_date, {
        modelValue: _ctx.localValue.fiscalData.birthDate,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.fiscalData.birthDate) = $event)),
        disabled: _ctx.needsFiscalCode,
        onClick: _ctx.alertFiscalCode
      }, null, 8, ["modelValue", "disabled", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Luogo di nascita",
          text: "Luogo di nascita"
        })
      ]),
      (_ctx.needsFiscalCode)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "form-control",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.alertFiscalCode && _ctx.alertFiscalCode(...args)))
          }, _toDisplayString(_ctx.localValue.fiscalData.birthPlace), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localValue.fiscalData.birthPlace) = $event))
          }, null, 512)), [
            [_vModelText, _ctx.localValue.fiscalData.birthPlace]
          ])
    ])
  ]))
}